/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-23 14:49:19
 *
 *******************************************************/
// @flow

class WeightHelper {
  /**
   * Init values from first loading
   *
   * @param  {object} filterOption  filter option value
   * @param  {object} initialValue default values
   *
   * @return {object}               init values
   */
  static initialValues = (filterOption, initialValue) => {
    const { sliderRange, sliderStep, sliderDelimiter } = filterOption;

    const result = {
      ...initialValue,
      weightSliderRange: sliderRange,
      weightSliderStep: sliderStep,
      weightSliderDelimiter: sliderDelimiter
    };

    return result;
  };

  /**
   * Build filter option data based on input values
   *
   * @param  {object} filterOption    input values
   * @param  {object} defaultValues   default values
   *
   * @return {object}                 filter option values
   */
  static buildFilterOptionValues = (filterOption, defaultValues) => {
    const { weightSliderRange, weightSliderStep, weightSliderDelimiter } = filterOption;

    const result = {
      ...defaultValues,
      sliderRange: weightSliderRange,
      sliderStep: weightSliderStep,
      sliderDelimiter: weightSliderDelimiter,
      selectType: 'single',
      displayType: 'range',
      valueType: 'all'
    };

    return result;
  };

  /**
   * Fake product data for weight
   *
   * @param  {object} filterOption
   * @return {array}              list of product count
   */
  static fakeProductValues = filterOption => {
    const min = Math.floor(Math.random() * 100) + 1;
    return {
      min,
      max: min + 2308
    };
  };
}

export default WeightHelper;
